import React from 'react';
import { Link } from 'react-router-dom';
import { GitHub, Twitter, LinkedIn, Email, LocationOn, Phone, Business } from '@mui/icons-material';

const Footer = () => {
    return (
        <footer className="bg-neutral-900 text-white">
            {/* Main Footer Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid lg:grid-cols-5 md:grid-cols-3 gap-8">
                    {/* Company Info - Enhanced */}
                    <div className="lg:col-span-2">
                        <div className="flex items-center space-x-3 mb-6">
                            <div className="w-10 h-10 bg-gradient-to-r from-amber-500 to-amber-600 rounded-lg flex items-center justify-center">
                                <span className="text-white font-bold text-lg">N</span>
                            </div>
                            <div>
                <span className="text-2xl font-bold bg-gradient-to-r from-amber-400 to-amber-500 bg-clip-text text-transparent">
                  Netikash
                </span>
                                <span className="text-amber-200 font-medium ml-2">Developer</span>
                            </div>
                        </div>

                        <p className="text-neutral-300 mb-6 text-lg leading-relaxed max-w-md">
                            Plateforme d'intégration d'API pour développeurs. Sécurisez vos paiements en ligne
                            avec nos solutions modernes et fiables.
                        </p>

                        {/* Contact Info */}
                        <div className="space-y-3 mb-6">
                            <div className="flex items-center space-x-3 text-neutral-300">
                                <LocationOn className="text-amber-500" />
                                <span>1 Mpolo coin Kasangulu, Lubumbashi</span>
                            </div>
                            <div className="flex items-center space-x-3 text-neutral-300">
                                <Phone className="text-amber-500" />
                                <span>+243 994 896 388</span>
                            </div>
                            <div className="flex items-center space-x-3 text-neutral-300">
                                <Email className="text-amber-500" />
                                <span>support@netikash.com</span>
                            </div>
                        </div>

                        {/* Social Links - Enhanced */}
                        <div className="flex space-x-4">
                            {[
                                { icon: GitHub, href: "#", label: "GitHub" },
                                { icon: Twitter, href: "#", label: "Twitter" },
                                { icon: LinkedIn, href: "#", label: "LinkedIn" },
                                { icon: Email, href: "#", label: "Email" }
                            ].map((social, index) => (
                                <a
                                    key={index}
                                    href={social.href}
                                    className="group relative p-3 bg-neutral-800 rounded-lg hover:bg-amber-500 transition-all duration-300 transform hover:-translate-y-1"
                                    aria-label={social.label}
                                >
                                    <social.icon className="text-neutral-400 group-hover:text-white transition-colors" />
                                    <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-amber-500 text-white px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
                                        {social.label}
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Resources */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6 text-amber-400 flex items-center">
                            <Business className="mr-2" />
                            Ressources
                        </h3>
                        <ul className="space-y-3">
                            {[
                                { path: "/documentation", label: "Documentation API" },
                                { path: "/integration", label: "Guide d'Intégration" },
                                { path: "/examples", label: "Exemples de code" },
                                { path: "/api-reference", label: "Référence API" },
                                { path: "/sdks", label: "SDKs & Libraries" }
                            ].map((link, index) => (
                                <li key={index}>
                                    <Link
                                        to={link.path}
                                        className="text-neutral-300 hover:text-amber-400 transition-colors duration-200 flex items-center group"
                                    >
                                        <span className="w-1 h-1 bg-amber-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Support */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6 text-amber-400 flex items-center">
                            <Phone className="mr-2" />
                            Support
                        </h3>
                        <ul className="space-y-3">
                            {[
                                { path: "/contact", label: "Contact Commercial" },
                                { path: "/technical-support", label: "Support Technique" },
                                { path: "/faq", label: "FAQ" },
                                { path: "/status", label: "Statut des services" },
                                { path: "/help-center", label: "Centre d'aide" }
                            ].map((link, index) => (
                                <li key={index}>
                                    <Link
                                        to={link.path}
                                        className="text-neutral-300 hover:text-amber-400 transition-colors duration-200 flex items-center group"
                                    >
                                        <span className="w-1 h-1 bg-amber-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Legal & Company */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6 text-amber-400 flex items-center">
                            <Business className="mr-2" />
                            Entreprise
                        </h3>
                        <ul className="space-y-3">
                            {[
                                { path: "/about", label: "À propos" },
                                { path: "/careers", label: "Carrières" },
                                { path: "/blog", label: "Blog Technique" },
                                { path: "/privacy", label: "Confidentialité" },
                                { path: "/terms", label: "Conditions" }
                            ].map((link, index) => (
                                <li key={index}>
                                    <Link
                                        to={link.path}
                                        className="text-neutral-300 hover:text-amber-400 transition-colors duration-200 flex items-center group"
                                    >
                                        <span className="w-1 h-1 bg-amber-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            {/* Newsletter Section */}
            <div className="border-t border-neutral-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <div>
                            <h4 className="text-lg font-semibold text-amber-400 mb-2">
                                Restez informé
                            </h4>
                            <p className="text-neutral-300">
                                Recevez les dernières actualités sur nos APIs et fonctionnalités
                            </p>
                        </div>
                        <div className="flex space-x-3 w-full md:w-auto">
                            <input
                                type="email"
                                placeholder="Votre email professionnel"
                                className="px-4 py-2 bg-neutral-800 border border-neutral-700 rounded-lg text-white placeholder-neutral-400 focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 flex-1 md:flex-none md:w-64"
                            />
                            <button className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-2 rounded-lg font-medium hover:from-amber-600 hover:to-amber-700 transition-all transform hover:-translate-y-0.5 shadow-lg hover:shadow-amber-500/25">
                                S'abonner
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-neutral-800 bg-neutral-950">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <div className="text-neutral-400 text-sm">
                            <p>&copy; 2024 Netikash Developer Portal. Tous droits réservés.</p>
                        </div>

                        <div className="flex space-x-6 text-sm text-neutral-400">
                            <Link to="/privacy" className="hover:text-amber-400 transition-colors">
                                Confidentialité
                            </Link>
                            <Link to="/terms" className="hover:text-amber-400 transition-colors">
                                Conditions
                            </Link>
                            <Link to="/cookies" className="hover:text-amber-400 transition-colors">
                                Cookies
                            </Link>
                            <Link to="/compliance" className="hover:text-amber-400 transition-colors">
                                Conformité PCI DSS
                            </Link>
                        </div>

                        <div className="text-neutral-400 text-sm flex items-center space-x-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                            <span>Tous systèmes opérationnels</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;